import Axios from "@app/api/axios";

import { INTEGRATIONS_API_URL } from "@utils/constant";

const addCredentials = () => Axios.post(`${INTEGRATIONS_API_URL}/credentials`);

export default addCredentials;
